export const BadgeServiceType = (props) => {
  // input
  const { service_type = null} = props;

  switch(service_type?.toUpperCase()) {
    case 'FAULTY': return (
      <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 shadow-sm ring-1 ring-inset ring-red-600/20">
        Breakdown
      </span>
    )
    case 'SITEVISIT': return (
      <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-800 shadow-sm ring-1 ring-inset ring-red-600/20">
        Site Visit
      </span>
    )
    case 'INSPECTION': return (
      <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-800 shadow-sm ring-1 ring-inset ring-blue-600/20">
        Inspection
      </span>
    )
    case 'FITTING': return (
      <span className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-800 shadow-sm ring-1 ring-inset ring-indigo-600/20">
        Fitting
      </span>
    )
    case 'MAKEGOOD':
    case 'MAKE_GOOD': return (
      <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-800 shadow-sm ring-1 ring-inset ring-green-600/20">
        Installation
      </span>
    )
    default: return (
      <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 shadow-sm ring-1 ring-inset ring-gray-500/10">
        {service_type ? service_type : 'Unknown'}
      </span>
    )
  }
}